import { gql } from '@apollo/client'

import { ClusterDocResults } from '../../components'

export const TesesJuridicasChatRoot = gql`
  query tesesJuridicasChatRoot($filters: [FilterInput], $limit: Int) {
    root {
      searchHaystack(query: "", kinds: [JURISPRUDENCE], limit: $limit, filters: $filters) {
        hits
        items {
          ...ClusterDocResults_haystackItem
        }
      }
    }
  }
  ${ClusterDocResults.fragments.haystackItem}
`
